module.exports = __webpack_public_path__ + "static/media/Leanne S.1a4dcb5a.jpg";